export default __webpack_public_path__ + "static/media/Ficha_sorgo_ZH.8afd0d28.png";